// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-button{width:-moz-fit-content;width:fit-content;display:block;border-radius:0 20px 0 20px!important;margin:var(--base-button-margin)}", ""]);
// Exports
module.exports = exports;
